"use strict";
import Pusher from "pusher-js";
export function createPusherInstance() {
  return new Pusher(PusherConfig.apiKey);
}
